import { useState, useContext, useEffect, useRef } from "react"
import { CommaFire, CSkeletonPlan, toast } from "../../components/widget"
import { ContextNav, ContextAbsence, ContextLoading, ContextDashboard } from "../../context";
import { PlanListApi, BuyPanelApi , CheckDiscountApi} from "../../api";
import { DatePicker } from "jalali-react-datepicker";
import { convertDateToString, converDurationToMin } from "../../utils";
import { useNavigate } from 'react-router-dom'

export const Plan = () => {
    const navigate = useNavigate()
    const formRef:any = useRef()
    const CtxNav = useContext(ContextNav)
    const CtxLoad = useContext(ContextLoading)
    const CtxDash = useContext(ContextDashboard)
    const [tableData, setTableData] = useState<any>([])
    const [selectedPanel, setSelectedPanel] = useState<any>(null)
    const [discount, setDiscount] = useState<any>({
        'amount':0 ,
        'code':null ,
    })

    const handelSelect = (item: any) => {
        setSelectedPanel(item)
    }

    const handelCheckDiscount=async(e:any)=>{
        e.preventDefault()
        if (selectedPanel == null) return toast("ابتدا یک پلن انتخاب نمایید", { type: "error" })
        CtxLoad.setDisplayLoadingBlur(true)
        let res = await CheckDiscountApi(selectedPanel , formRef)
        CtxLoad.setDisplayLoadingBlur(false)
        if (res.success) {
            setDiscount({
                'amount':+res.data ,
                'code':formRef.current['discount'].value ,
            })
            toast(res.message, { type: "success" })
        }
        else {
            toast(res.message, { type: "error" })
        }
    }

    const startPayment = async () => {
        if (selectedPanel == null) return
        CtxLoad.setDisplayLoadingBlur(true)
        let res = await BuyPanelApi(selectedPanel , discount)
        if (res.success) {
            window.location.href = res.data
        }
        else {
            CtxLoad.setDisplayLoadingBlur(false)
            toast(res.message, { type: "error" })
        }
    }

    const getData = async () => {
        try {
            CtxLoad.setDisplayLoadingSkelton(true)
            let res = await PlanListApi()
            setTableData(res.data.plans)
            CtxLoad.setDisplayLoadingSkelton(false)
        }
        catch (err: any) {
            CtxLoad.setDisplayLoadingSkelton(false)
        }
    }

    useEffect(() => {
        document.title = " پلن ها | دایان"
        CtxNav.setActiveMenuItem({ 'item': -1, 'subItem': 0, })
        getData()

    }, [])

    return (
        <div className=" w-full flex flex-col">
            <h1 className="sm:text-2xl text-lg font-bold mb-[30px]">مدیریت پلن</h1>

            {CtxLoad.displayLoadingSkelton == false ?
                <div className=" w-full flex flex-wrap ">
                    {tableData.map((item: any, index: number) =>
                        <div key={index} className="md:w-3/12 w-full p-2">
                            <div className={`w-full py-3 bg-white rounded-lg shadow flex flex-col justify-center items-center ${selectedPanel?.id == item.id && 'border-2 border-dayan-orange-50'}`}>
                                {(item.image && item.image != null) ?
                                    <img src={item.imaege} className="w-[100px] rounded-md" />
                                    :
                                    <img src='/assetes/logo/logo.png' className="w-[100px] rounded-md" />
                                }
                                <span className="mt-4">پلن {item.name}</span>
                                <span className="mt-2 text-gray-500 text-sm"> {CommaFire(item.amount)} تومان</span>
                                <button onClick={() => handelSelect(item)} className="text-white bg-blue-600 rounded text-sm w-[85%] h-[38px] mt-4">سفارش</button>
                            </div>
                        </div>
                    )}
                </div>
                :
                <CSkeletonPlan />
            }

            <div id="checkout" className={` flex-col  rounded-lg  bg-white mt-4  opacity-100 visible w-full h-fit px-3 py-6 shadow`}>
                <form ref={formRef} onSubmit={handelCheckDiscount} className="w-full flex items-center sm:flex-row flex-col">
                    <span className="text-sm text-gray-700 sm:mb-0 mb-2">آیا کد تخفیف دارید ؟</span>
                    <div className="flex items-center">
                        <input type={'text'} name='discount' className='w-6/12 h-[35px] rounded border mx-2 focus:outline-none px-1 text-sm' placeholder="کد تخفیف" />
                        <button className=" w-6/12 h-[35px] rounded bg-[tomato] text-white text-sm">اعمال</button>
                    </div>
                </form>

                <div className="w-full flex justify-end">
                    <div className="sm:w-[300px] w-full flex flex-col mt-5">
                        <div className="flex items-center justify-between">
                            <span className="text-xs text-gray-600">مبلغ سرویس :</span>
                            {selectedPanel != null &&
                                <span className="text-sm">{CommaFire(selectedPanel?.amount)} تومان</span>
                            }
                        </div>
                        <div className="flex items-center justify-between mt-3">
                            <span className="text-xs text-gray-600">میزان تخفیف :</span>
                            {selectedPanel != null &&
                                <span className="text-sm">{CommaFire(discount?.amount)} تومان</span>
                            }
                        </div>
                        <div className="flex items-center justify-between mt-3">
                            <span className="text-xs text-gray-600">مبلغ قابل پرداخت :</span>
                            {selectedPanel != null &&
                                <span className="text-sm">{CommaFire(selectedPanel?.amount - discount?.amount)} تومان</span>
                            }
                        </div>
                        {selectedPanel != null &&
                            <button type="button" onClick={startPayment} className="w-full h-[40px] bg-green-600 text-white rounded mt-5">پرداخت</button>
                        }
                    </div>
                </div>ّّ
            </div>

        </div>
    )
}
